import * as styles from './styles.css';
import { KEEP_OFFER_PREVIEW_OPEN_ATTR } from '../../../../../constants/offerPreview';
import { EPinAction, PIN_ACTION_ATTR } from '../../../../../constants/pinActions';
import { CHEVRON_LEFT_SMALL_ICON, CHEVRON_RIGHT_SMALL_ICON } from '../../constants';

export interface IPinPaginationProps {
  /** Позиция показанного объявления, с единицы */
  current: number;
  total: number;
}

function getButtonRenderer(action: EPinAction, icon: string, label: string): string {
  return `<button type="button" class="${styles['button']}" ${PIN_ACTION_ATTR}="${action}" aria-label="${label}" data-testid="pin-pagination-${action}">${icon}</button>`;
}

/**
 * Пагинация активного мультипина: «‹ current / total ›».
 * Только вёрстка: кнопки несут атрибут действия, обработчик кликов живёт снаружи.
 * Клик по пагинации не закрывает превью объявления (KEEP_OFFER_PREVIEW_OPEN_ATTR).
 */
export function getPaginationRenderer({ current, total }: IPinPaginationProps): string {
  return `<div class="${styles['pagination']}" data-testid="pin-pagination" ${KEEP_OFFER_PREVIEW_OPEN_ATTR}>${getButtonRenderer(
    EPinAction.PrevOffer,
    CHEVRON_LEFT_SMALL_ICON,
    'Предыдущее объявление',
  )}<span class="${styles['label']}" data-testid="pin-pagination-label"><span data-testid="pin-pagination-current">${current}</span><span class="${styles['slash']}">/</span><span data-testid="pin-pagination-total">${total}</span></span>${getButtonRenderer(
    EPinAction.NextOffer,
    CHEVRON_RIGHT_SMALL_ICON,
    'Следующее объявление',
  )}</div>`;
}
